import { memo } from 'react';

import SvgIcon from '@material-ui/core/SvgIcon';

import { colors } from '../theme/palette';
import { SvgIconProps } from './SvgIcon.types';

export const MergeIcon = memo(({ color = colors.basic.black, fontSize = 16, className }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="1 3 23 18" fill="none" className={className} style={{ fontSize }}>
      <path
        d="M3.30302 5.29782L6.37836 5.34761C7.9809 5.37356 9.47735 6.02187 10.5921 7.17331L13.4686 10.1453C13.8205 10.5088 14.2254 10.8011 14.6636 11.0242C14.0878 11.1889 13.5392 11.4358 13.0256 11.7501C12.8041 11.5777 12.5895 11.3942 12.3911 11.1892L9.51457 8.21726C8.67795 7.3531 7.55542 6.86686 6.35408 6.84741L3.27873 6.79762L3.30302 5.29782ZM19.3933 11.5591L16.6284 11.5143C15.0258 11.4884 13.5092 12.0879 12.3577 13.2027L9.38652 16.08C8.52312 16.9158 7.38544 17.3655 6.1841 17.346L3.10876 17.2962L3.08447 18.7961L6.15982 18.8458C7.76236 18.8718 9.27901 18.2723 10.4305 17.1575L13.4017 14.2802C14.2651 13.4443 15.4028 12.9947 16.6041 13.0142L19.369 13.0589L17.6216 14.7506L18.6648 15.8281L22.2517 12.3555L18.7791 8.76856L17.7016 9.81175L19.3933 11.5591Z"
        fill={color}
      />
    </SvgIcon>
  );
});
